import NewHeroSection from '../components/NewHeroSection';
import Honecard from '../components/Honecard';
import AboutUs from '../components/AboutUs';
import Services from '../components/Services';
import FAQ from '../components/FAQ';
import SEO from '../components/SEO';
import PageTransition from '../components/PageTransition';
import ScrollReveal from '../components/ScrollReveal';

export default function HomePage() {
  return (
    <PageTransition>
      <SEO translationKey="seo.home" />
      <div className="min-h-screen">
        <NewHeroSection />
        <ScrollReveal>
          <Honecard />
        </ScrollReveal>
        {/* <ContactInfo /> */}
        <ScrollReveal>
          <AboutUs />
        </ScrollReveal>
        <ScrollReveal>
          <div id="services">
            <Services />
          </div>
        </ScrollReveal>
        <ScrollReveal>
          <FAQ />
        </ScrollReveal>
      </div>
    </PageTransition>
  );
}

